export default "__VITE_ASSET__DNR8WQCN__"